import React from 'react';
import classNames from 'classnames';

import { Member } from '@wix/members-domain-ts';

import styles from './details.scss';
import MemberName from '../../member-name';
import RoleIcons from '../../../containers/role-icons';
import Blocked from '../../blocked';

interface Props {
  member: Member;
  goToMemberPage: (id: string) => void;
  showAsBlocked?: boolean;
}

export const Details: React.StatelessComponent<Props> = ({ member, goToMemberPage, showAsBlocked }) => (
  <div className={styles.container}>
    <span className={styles.truncateName}>
      <MemberName name={member.name} member={member} goToMemberPage={goToMemberPage} />
    </span>

    <RoleIcons
      roles={member.roles}
      containerClassName={classNames([styles.detailsRoleIcons, 'ma-primary-font'])}
      iconClassName="ma-fill-primary-text"
    />
    {showAsBlocked && <Blocked className={classNames(['ma-primary-font', styles.blocked])} />}
  </div>
);
